import { SelectButton } from "primereact/selectbutton";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Textbox, Textarea } from "react-inputs-validation";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  Row,
} from "reactstrap";
import { FetchValidarPlacasPolizaCarrito } from "../../redux/actions/ACarritoProductos";
import { setCorreo } from "../../redux/actions/aCotizacion";
import "../../styles/estilos.css";
import moment from "moment";
import { apiGet } from "../../api";
import { urlCalcularRenovaciones, urlGuardarRenovaciones } from "../../constants/urls";
import ConfirmDialog from "../Compras/ConfirmDialog";
import { totales } from "../../constants";
import { validarBotonRenovar } from "../../redux/actions/aLogin";

class ValoresRenovacion extends React.Component {
  constructor(props) {

    console.log('dataRenovacion', props.dataRenovacion)
    super(props);
    this.state = {
      errorCalular: false,
      mensajeErrorCalcular: '',
      correo: "",
      visibleAlert: true,
      height: window.innerHeight,
      claseDivFix: "flex-row div-flotante",
      claseDivFixPlan: "flex-row div-flotante-km",
      selectedItem: this.props.planSeleccionado,
      correo: "",
      errorRenovaciones: false,
      mensajeErrorRenovaciones: '',
      validate: false,
      tieneError: true,
      visibleAlert: true,
      isConfirmOpen: false,
      confirmAction: null,
      message: '',
      planes:

        this.props.dataRenovacion.productoExterno ?

          [

            {
              "codigo": "",
              "vigenciaMeses": "3 meses",
              "vigenciaDias": "",
              "plan": "",
              "valor": 0,
              "valorImpuestos": "20.84",
              "deducible": "200",
              "limiteRC": "20000"
            }

          ]
          :



          this.props.producto == 'PRACTIAUTO' ? [
            {
              "codigo": "PRACTIAUTO",
              "vigenciaMeses": "3 meses",
              "vigenciaDias": "",
              "plan": "PRACTIAUTO",
              "valor": parseFloat(this.props.dataRenovacion.total) + 75,
              "valorImpuestos": "20.84",
              "deducible": "200",
              "limiteRC": "20000"
            }
          ] : !this.esFullCobertura() ?
            [
              {
                "codigo": "AIGAUTO",
                "vigenciaMeses": "3 meses",
                "vigenciaDias": "",
                "plan": "AIG AUTO",
                "valor": this.props.dataRenovacion.total,
                "valorImpuestos": "20.84",
                "deducible": "200",
                "limiteRC": "20000"
              }
            ] : [
              {
                "codigo": "AIGAUTO",
                "vigenciaMeses": "3 meses",
                "vigenciaDias": "",
                "plan": "AIG AUTO",
                "valor": this.props.dataRenovacion.total,
                "valorImpuestos": "20.84",
                "deducible": "200",
                "limiteRC": "20000"
              },
              {
                "codigo": "PRACTIAUTO",
                "vigenciaMeses": "3 meses",
                "vigenciaDias": "",
                "plan": "PRACTIAUTO",
                "valor": parseFloat(this.props.dataRenovacion.total) + 75,
                "valorImpuestos": "20.84",
                "deducible": "200",
                "limiteRC": "20000"
              }
            ]

      ,
      planSeleccionado:

        this.props.dataRenovacion.productoExterno ?

          {
            "codigo": "",
            "vigenciaMeses": "3 meses",
            "vigenciaDias": "",
            "plan": "",
            "valor": 0,
            "valorImpuestos": "20.84",
            "deducible": "200",
            "limiteRC": "20000"
          } :





          this.props.producto == 'PRACTIAUTO' ? {
            "codigo": "PRACTIAUTO",
            "vigenciaMeses": "3 meses",
            "vigenciaDias": "",
            "plan": "PRACTIAUTO",
            "valor": parseFloat(this.props.dataRenovacion.total) + 75,
            "valorImpuestos": "20.84",
            "deducible": "200",
            "limiteRC": "20000"
          } : {
            "codigo": "AIGAUTO",
            "vigenciaMeses": "3 meses",
            "vigenciaDias": "90 días",
            "plan": "AIG AUTO",
            "valor": this.props.dataRenovacion.total,
            "valorImpuestos": "20.84",
            "deducible": "200",
            "limiteRC": "20000"
          }

      ,
      total: {
        prima_neta_anual_full_cobertura: "0.00",
        super_bancos_Full_Cobertura: "0.00",
        seguro_campesino_Full_Cobertura: "0.00",
        derecho_emision_Full_Cobertura: "0.00",
        primaTotal_Full_Cobertura: "0.00",
        iva_Full_Cobertura: "0.00",
        totalImpuestos: "0.00",
      }
    };
    this.handleScroll = this.handleScroll.bind(this);
    this.onDismiss = this.onDismiss.bind(this);



  }

  async componentDidMount() {





  }

  toggleConfirm = () => {
    this.setState((prevState) => ({
      isConfirmOpen: !prevState.isConfirmOpen,
    }));
  };





  onDismiss() {
    this.setState({ visibleAlert: false });
  }

  editarForm = (formEditado) => {
    this.setState({ formEditado });
  };

  toggleValidating(validate) {
    this.setState({ validate });
  }






  esFullCobertura = () => {

    let esFull = true
    let renovacion = this.props.dataRenovacion

    let vehiculos = renovacion.vehiculoAll

    vehiculos.forEach(vehiculo => {

      if (vehiculo.rePlanSeleccionado != 'fullCobertura') {
        esFull = false
      }


    });

    let validacion = esFull

    return validacion

  }


  onClickContinuar = async (numeroPolizaEmision, anio, renovar, codigoEspecial, producto) => {

    this.setState({
      isConfirmOpen: true,
      message: `¿Estás seguro de que deseas realizar la ${renovar ? 'renovación' : 'recotización'}?`,
      confirmAction: () =>
        this.renovarPoliza(numeroPolizaEmision, anio, renovar, codigoEspecial, producto)
    });
    // eslint-disable-next-line no-restricted-globals
    /*    const answer = confirm("¿Estás seguro de que deseas realizar la renovación?")
       if (answer) {
         this.renovarPoliza(numeroPolizaEmision, anio, renovar, codigoEspecial, producto)
       } */
  }


  obtenerCodigoEspecial2 = (producto) => {

    console.log('llegue2', producto)

    switch (producto) {
      case 'AIGAUTO':
        return 'comparador'
        break;

      case 'PRACTIAUTO':
        return 'pits'
        break;

      default:
        return 'externo'
        break;
    }
  }

  renovarPoliza = async (numeroPolizaEmision, anio, renovar, codigoEspecial, producto) => {


    this.props.setLoading(true)

    const yearVariable = parseInt(anio); // Ejemplo de año en la variable
    const currentYear = moment().year(); // Obtiene el año actual con moment()

    const difference = currentYear - yearVariable;
    const bloquearFullCobertura = difference >= 15


    //return console.log('yearVariable', yearVariable, currentYear, difference, bloquearFullCobertura)





    const data = await apiGet(`${urlGuardarRenovaciones}${numeroPolizaEmision}&producto=${this.state.planSeleccionado.codigo}`)





    if (data.transaccion) {









      this.props.history.push({
        pathname: "/resumen-cotizacion-renovacion",
        search: `?id=${data.data.idCarrito}${this.props.dataRenovacion.noPortal == true ? '&esNoPortal=true' : ''}&paso=resumen&codigoProductoEspecial=${this.obtenerCodigoEspecial2(this.state.planSeleccionado.codigo)}${renovar ? '&esRenovacion=true' : ''}${renovar && bloquearFullCobertura ? '&bloquearFullCobertura=true' : ''}`

      });





    } else {

      this.setState({
        errorRenovaciones: true,
        mensajeErrorRenovaciones: data.errorDescripcion
      })
    }

    this.props.setLoading(false)




  }


  calcularTotales = async (planSeleccionado) => {

    this.props.setLoading(true)

    //return {transaccion: true}
    try {
      console.log('Siniestralidad:', this.props.detalleCarrito);

      const url = `${urlCalcularRenovaciones}&idRenovacion=${this.props.dataRenovacion._id}&tipoPoliza=${planSeleccionado} `;
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error('Error al obtener la siniestralidad. Intente nuevamente más tarde.');
      }



      let json = await response.json();

      let data = json[0]


      let suma = this.sumarValoresTotales(json)





      if (data.transaccion) {
        this.setState({
          total: suma,
          errorCalular: false,
          mensajeErrorCalcular: ''
        })
      } else {

        this.setState({
          errorCalular: true,
          mensajeErrorCalcular: data.mensaje
        })
      }






    } catch (error) {
      console.error('Error en validarSiniestralidad:', error);

      this.setState({
        errorCalular: true,
        mensajeErrorCalcular: 'Ocurrió un problema con el servicio. Por favor, contacte a soporte técnico.'
      })

    } finally{
      this.props.setLoading(false)
    }
  }

   sumarValoresTotales = (data) => {
    const keysToSum = [
        "primaNeta",
        "prima_neta_anual_full_cobertura",
        "super_bancos_Full_Cobertura",
        "seguro_campesino_Full_Cobertura",
        "derecho_emision_Full_Cobertura",
        "iva_Full_Cobertura",
        "primaTotal_Full_Cobertura",
        "totalImpuestos"
    ];
    
    let resultado = {};
    
    // Inicializar todas las claves en 0
    keysToSum.forEach(key => resultado[key] = 0);
    
    // Recorrer el array de datos
    data.forEach(item => {
        if (Array.isArray(item.valoresTotales)) {
            item.valoresTotales.forEach(valor => {
                keysToSum.forEach(key => {
                    if (valor[key] !== undefined) {
                        resultado[key] += valor[key];
                    }
                });
            });
        }
    });
    
    return resultado;
}

  calcularTotales2 = async (planSeleccionado) => {


    this.props.setLoading(true)


    //return console.log('yearVariable', yearVariable, currentYear, difference, bloquearFullCobertura)




    let data = await apiGet(`${urlCalcularRenovaciones}&idRenovacion=${this.props.dataRenovacion._id}&tipoPoliza=${planSeleccionado} `)










    if (data && data.transaccion) {






      this.setState({
        total: data.valoresTotales[0]
      })








    } else {

    }

    this.props.setLoading(false)




  }


  obtenerCodigoEspecial = (producto) => {

    console.log('llegue2', producto)

    switch (producto) {
      case 'AIGAUTO':
        return 'comparador'
        break;

      case 'PRACTIAUTO':
        return 'pits'
        break;

      default:
        return ''
        break;
    }
  }

  onClickEnviar = (event) => {

    event.preventDefault();

    this.setState({ validate: !this.state.validate })

    if (!this.state.tieneError) {
      this.props.metodoEnviar(event);
    }


  };
  /* Eventos Scroll */
  handleScroll() {
    const windowHeight =
      "innerHeight" in window
        ? window.innerHeight
        : document.documentElement.offsetHeight;
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    const windowBottom = windowHeight + window.pageYOffset;
    if (this.props.paso === "resumen-cotizacion") {
      //console.log("total this.props.detalleCarrito.productosCarrito.carProductos.length",this.props.detalleCarrito.productosCarrito.carProductos.length)
      if (
        this.props.detalleCarrito &&
        this.props.detalleCarrito.productosCarrito.carProductos.length > 1
      ) {
        if (windowBottom >= docHeight - 300) {
          this.setState({
            claseDivFix:
              "flex-row div-flotante fix-botton-totales-resumen-multi",
            claseDivFixPlan:
              "flex-row div-flotante-km fix-botton-totales-resumen-multi",
          });
        } else {
          this.setState({
            claseDivFix: "flex-row div-flotante",
            claseDivFixPlan: "flex-row div-flotante-km",
          });
        }
      } else {
        if (windowBottom >= docHeight - 300) {
          this.setState({
            claseDivFix: "flex-row div-flotante fix-botton-totales-resumen",
            claseDivFixPlan:
              "flex-row div-flotante-km fix-botton-totales-resumen",
          });
        } else {
          this.setState({
            claseDivFix: "flex-row div-flotante",
            claseDivFixPlan: "flex-row div-flotante-km",
          });
        }
      }
    } else {
      if (windowBottom >= docHeight - 120) {
        this.setState({
          claseDivFix: "flex-row div-flotante fix-botton-totales",
          claseDivFixPlan: "flex-row div-flotante-km fix-botton-totales",
        });
        //console.log("Scroll TOP");
      } else {
        this.setState({
          claseDivFix: "flex-row div-flotante",
          claseDivFixPlan: "flex-row div-flotante-km",
        });
      }
    }
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);

    this.calcularTotales(this.state.planSeleccionado.codigo)
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  onClickRecompra = async (id) => {
    this.props.history.push({
      pathname: "/recompra",
      search: `?id=${id}`

    });

  }

  convertirANumero = (s) => {
    try {
      // Reemplaza la coma por un punto para convertir correctamente a número
      let numero = parseFloat(s);

      if (isNaN(numero)) {
        throw new Error("Valor no numérico");
      }

      // Formatear con separador de miles y dos decimales
      return numero.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch (error) {
      // Si hay un error, devuelve "0.00" en el formato correcto
      return "0.00";
    }
  }


  onClickContinuarProceso = async (idCarrito, anio, producto) => {

    const yearVariable = parseInt(anio); // Ejemplo de año en la variable
    const currentYear = moment().year(); // Obtiene el año actual con moment()

    const difference = currentYear - yearVariable;
    const bloquearFullCobertura = difference >= 15


    this.props.history.push({
      pathname: "/resumen-cotizacion-renovacion",
      search: `?id=${idCarrito}${this.props.dataRenovacion.noPortal == true ? '&esNoPortal=true' : ''}&paso=resumen&codigoProductoEspecial=${producto}&esRenovacion=true${bloquearFullCobertura ? '&bloquearFullCobertura=true' : ''}`

    });
  }

  obtenerCodigoEspecial = (producto) => {

    switch (producto) {
      case 'AIG AUTO':
        return 'comparador'
        break;

      case 'PRACTIAUTO':
        return 'pits'
        break;

      default:
        return ''
        break;
    }
  }

  itemTemplate = (option) => {
    //console.log(option);
    return (
      <div
        className='container w-100'
        style={{
          width: "100%",
          border: "",
          borderRadius: "4px",
          lineHeight: "15px",
          paddingTop: 10,
          paddingBottom: 10
        }}
        key={option.codigo}>
        <small style={{ fontSize: "10px", }}>{option.plan}</small>
        {/*     <br />
        <strong style={{ fontSize: "11px" }}>${option.valor}</strong> */}
        <br />

      </div>
    );
  };

  onChangeItem = ({ value }) => {
    //value=== plan

    if (value && value.codigo) {

      this.setState({
        planSeleccionado: value
      })

      this.calcularTotales(value.codigo)

    }

  };

  onActualizar = ({ value }) => {
    //value=== plan
    this.props.onActualizar();
  };

  render() {
    let textoBoton = "CONTINUAR";
    let { formEditado, completo, dataRenovacion } = this.props;

    let total = {
      prima_neta_anual_full_cobertura: "0.00",
      super_bancos_Full_Cobertura: "0.00",
      seguro_campesino_Full_Cobertura: "0.00",
      derecho_emision_Full_Cobertura: "0.00",
      primaTotal_Full_Cobertura: "0.00",
      iva_Full_Cobertura: "0.00",
      totalImpuestos: "0.00",
    };

    if (dataRenovacion && dataRenovacion.impuestos) {

      total = dataRenovacion.impuestos

    }

    console.log('dataRenovacion222', dataRenovacion)
    const {
      correo,
      claseDivFix,
      claseDivFixPlan,
    } = this.state;
    if (
      this.props.paso === "confirmacion-cotizacion" &&
      this.props.dataUsuario.usu_tipo_usuario === "cliente"
    ) {
      textoBoton = "PAGAR";
    }

    return (
      <div>
        <div>
          {
            (validarBotonRenovar(dataRenovacion) && this.state.planes.length > 1)  &&

            
      



            <Card style={{ width: "99%" }}>


              <CardHeader style={{ position: "" }}>
                <strong>Selecciona un producto</strong>
              </CardHeader>
              <CardBody>
                <div>
                  <div class=''>
                    <Form>
                      {this.state.planes != null && (
                        <SelectButton
                          value={this.state.planSeleccionado}
                          disabled={completo}
                          options={this.state.planes}
                          onChange={this.onChangeItem}
                          optionLabel='codigo'
                          //optionValue="codigo"
                          itemTemplate={this.itemTemplate}
                          className='vertically w-100'
                          dataKey='codigo'
                        />
                      )}
                    </Form>
                  </div>
                </div>
              </CardBody>
            </Card>


          }

          <Card style={{ width: "99%" }}>
            {((this.props.codigoProductoEspecial &&
              this.props.codeProductoEspecial !== "KilometrosConsumidos" &&
              this.props.planes != null &&
              this.props.planes.length > 0) || (this.props.recompra)) && (
                <CardHeader style={{ position: "" }}>
                  <strong>Resumen</strong>
                </CardHeader>
              )}
            <CardBody>
              <div>
                {((this.props.codigoProductoEspecial &&
                  this.props.codeProductoEspecial !== "KilometrosConsumidos" &&
                  this.props.planes != null &&
                  this.props.planes.length > 0) || (this.props.recompra)) && (
                    <div>
                      <div class=''>
                        <Form style={{ width: "99%" }}>
                          {this.props.planes != null && (
                            <SelectButton
                              value={this.props.planSeleccionado}
                              disabled={completo}
                              options={this.props.planes}
                              onChange={this.onChangeItem}
                              optionLabel='codigo'
                              //optionValue="codigo"
                              itemTemplate={this.itemTemplate}
                              className='vertically w-100 my-3'
                              dataKey='codigo'
                            />
                          )}
                        </Form>
                      </div>
                    </div>
                  )}
              </div>
              <div>
                {(
                  <div>
                    <h4 style={{ fontWeight: "bold" }}>Valor del Seguro</h4>

                    <Row>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <p />
                        <h5 style={{ fontWeight: "bold" }}>Prima Neta</h5>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <p />
                        {/* <h5 style={{ fontWeight: "bold" }}>
                          $
                          {this.props.paso === "datos-cotizacion"
                            ? this.props.totales.primaTotal_Full_Cobertura
                            : this.props.totales.totalcarrito}
                        </h5> */}

                        <h5>${this.convertirANumero(this.state.total.primaNeta)}</h5>
                      </Col>
                    </Row>

                    <Row>
                      <div id='container-imp'>

                        <div className='accordion-imp'>
                          <input type='checkbox' id='tm' />
                          <label htmlFor='tm' className='accordionitem'>
                            <Row>
                              <Col lg={6} md={6} sm={6} xs={6}>
                                <h5
                                  title={
                                    "Presiona click para ver/ocultar el detalle impuestos"
                                  }>
                                  Impuestos{" "}
                                  <i
                                    className='fa fa-info-circle'
                                    aria-hidden='true'
                                  />
                                </h5>
                              </Col>
                              <Col lg={6} md={6} sm={6} xs={6}>
                                <h5>${this.convertirANumero(this.state.total.totalImpuestos)}</h5>
                              </Col>
                            </Row>
                          </label>
                          <div className='hiddentext ocultar'>
                            <Row>
                              <Col lg={6} md={6} sm={6} xs={6}>
                                <h5>IVA</h5>
                              </Col>
                              <Col lg={6} md={6} sm={6} xs={6}>
                                <h5>${this.convertirANumero(this.state.total.iva_Full_Cobertura)}</h5>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg={6} md={6} sm={6} xs={6}>
                                <h5>Super bancos 3.5 %</h5>
                              </Col>
                              <Col lg={6} md={6} sm={6} xs={6}>
                                <h5>${this.convertirANumero(this.state.total.super_bancos_Full_Cobertura)}</h5>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg={6} md={6} sm={6} xs={6}>
                                <h5>Seguro Campesino</h5>
                              </Col>
                              <Col lg={6} md={6} sm={6} xs={6}>
                                <h5>
                                  ${this.convertirANumero(this.state.total.seguro_campesino_Full_Cobertura)}
                                </h5>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg={6} md={6} sm={6} xs={6}>
                                <h5>Derechos de Emisión</h5>
                              </Col>
                              <Col lg={6} md={6} sm={6} xs={6}>
                                <h5>${this.convertirANumero(this.state.total.derecho_emision_Full_Cobertura)}</h5>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </Row>


                    <Row>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <p />
                        <h5 style={{ fontWeight: "bold" }}>Prima Total</h5>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <p />
                        {/* <h5 style={{ fontWeight: "bold" }}>
                          $
                          {this.props.paso === "datos-cotizacion"
                            ? this.props.totales.primaTotal_Full_Cobertura
                            : this.props.totales.totalcarrito}
                        </h5> */}

                        <h5>${this.convertirANumero(this.state.total.primaTotal_Full_Cobertura)}</h5>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={12} md={12} sm={12} xs={12}>

                        {this.props.urlPdf && formEditado == false && (
                          <div>
                            <hr />
                            <a
                              className='btn btn-detail-white'
                              href={this.props.urlPdf}
                              target='_blank'
                              rel='noopener noreferrer'>
                              <i
                                className='fa fa-cloud-download'
                                aria-hidden='true'
                              />{" "}

                              DESCARGAR COTIZACIÓN
                            </a>
                          </div>
                        )}
                      </Col>








                      {/* <Col lg={12} md={12} sm={12} xs={12}>
                      <Button
                        className='btn btn-detail-white'
                        onClick={this.onClickDescargar}>
                        <i
                          className='fa fa-cloud-download'
                          aria-hidden='true'
                        />{" "}
                        DESCARGAR COTIZACIÓN
                      </Button>
                      <br></br>
                    </Col> */}

                    </Row>
                    {this.props.urlPdf && formEditado == false &&
                      <Row>
                        <Col lg={8} md={12} sm={12} xs={12}>
                          <Textbox
                            tabIndex="1"
                            type="input"
                            value={this.props.email}
                            name="correo"
                            id="correo"
                            classNameInput={"form-control"}
                            onChange={(correo, e) => {
                              this.props.setEmail(correo)
                            }}
                            placeholder="Por favor ingrese el correo" // Optional.[String].Default: "".
                            validate={this.state.validate}
                            validationCallback={(res) => {

                              console.log('resfs', res)

                              //setHasCorreoError(res)
                              this.setState({ validate: !res, tieneError: res })



                            }} // Optional.[Func].Default: none. Return the validation result.
                            onBlur={(e) => {
                              // this.setState({ blur: true });
                              //console.log("BLUUUR");
                            }}
                            validationOption={{
                              name: "correo", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                              required: true,
                              reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                              regMsg: "Por favor ingrese un correo válido",
                              msgOnError: "Por favor ingrese un correo válido", // Optional.[Bool].Default: true. To determin if it is a required field.
                            }}
                          />
                        </Col>
                        <Col lg={4} md={12} sm={12} xs={12}>
                          <Button
                            className='btn btn-detail-white'
                            onClick={this.onClickEnviar}>
                            <i className='fa fa-envelope' aria-hidden='true' />{" "}
                            ENVIAR
                          </Button>

                        </Col>
                        {this.props.datosCotizacion.envioOK && (
                          <Alert
                            color='success'
                            isOpen={this.state.visibleAlert}
                            toggle={this.onDismiss}>
                            <center>
                              <p>
                                Se ha enviado correctamente la cotización al
                                correo electrónico ingresado.
                              </p>
                            </center>
                          </Alert>
                        )}




                      </Row>

                    }



                    <Row>
                      <Col lg={12} md={12} sm={12} xs={12}>





                        <hr></hr>


                        {
                          dataRenovacion.aplicarRecompra &&
                          <React.Fragment>

                            <Button
                              className={"btn btn-primary"}
                              onClick={(e) => this.onClickRecompra(dataRenovacion.reidPoliza)}

                              style={{ display: "block", margin: "auto" }}
                            >
                              <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                              {'Recompra'}
                            </Button>
                          </React.Fragment>
                        }


                        {
                          validarBotonRenovar(dataRenovacion) &&

                          !this.state.errorCalular && 

                          <React.Fragment>

                            <Button
                              className={"btn btn-primary"}
                              onClick={(e) => this.onClickContinuar(dataRenovacion.numeroPolizaEmision, dataRenovacion.anio, true, this.obtenerCodigoEspecial(dataRenovacion.polDescripcionSeguro, this.state.planSeleccionado.codigo))}
                              style={{ display: "block", margin: "auto" }}
                            >
                              <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                              {'Renovar'}
                            </Button>
                          </React.Fragment>
                        }

                        {
                          (!dataRenovacion.aplicarRecompra && dataRenovacion.estado == 'EN_PROCESO' && !this.state.errorCalular) &&

                          <React.Fragment>

                            <Button
                              className={"btn btn-primary"}
                              onClick={(e) => this.onClickContinuarProceso(dataRenovacion.reIdCarrito, dataRenovacion.anio, dataRenovacion.reProductoNuevo)}
                              style={{ display: "block", margin: "auto" }}
                            >
                              <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                              {'Continuar'}
                            </Button>
                          </React.Fragment>
                        }

                        {
                          (!dataRenovacion.aplicarRecompra && dataRenovacion.estado == 'VENCIDAS') &&

                          <React.Fragment>

                            <Button
                              className={"btn btn-primary"}
                              onClick={(e) => this.onClickContinuar(dataRenovacion.numeroPolizaEmision, dataRenovacion.anio, false, this.obtenerCodigoEspecial(dataRenovacion.polDescripcionSeguro), this.state.planSeleccionado.codigo)}
                              style={{ display: "block", margin: "auto" }}
                            >
                              <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                              {'Crear carrito'}
                            </Button>
                          </React.Fragment>
                        }

                        {
                          (!dataRenovacion.aplicarRecompra && dataRenovacion.estado == 'NO_RENOVADAS') &&

                          <React.Fragment>

                            <p>
                              {dataRenovacion.mensajeNoRenovables}
                            </p>
                          </React.Fragment>
                        }


                        <br></br>
                      </Col>
                    </Row>

                  </div>
                )}












              </div>









            </CardBody>
          </Card>


          {this.state.errorCalular && (
            <Alert
              color='danger'
              isOpen={this.state.errorCalular}
              toggle={this.onDismiss}>
              <center>
                <p>
               
               {this.state.mensajeErrorCalcular}
                </p>
              </center>
            </Alert>
          )}
          {
            this.state.errorRenovaciones &&
            <Alert
              color='danger'
              isOpen={this.state.errorRenovaciones}
              toggle={this.onDismiss}>
              <center>
                <p>
                  {this.state.mensajeErrorRenovaciones}
                </p>
              </center>
            </Alert>
          }

        </div>
        <ConfirmDialog
          isOpen={this.state.isConfirmOpen}
          toggle={this.toggleConfirm}
          message={this.state.message}
          onConfirm={() => {
            if (this.state.confirmAction) this.state.confirmAction();
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  detalleCarrito: state.dataProductoCarrito,
  dataUsuario: state.datosUsuarios.dataUsuario,
  datosCotizacion: state.datosCotizacion,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setCorreo: (data) => dispatch(setCorreo(data)),
    fetchValidarPlacasPolizaCarrito: (datos) =>
      dispatch(FetchValidarPlacasPolizaCarrito(datos)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ValoresRenovacion)
);